import { render, staticRenderFns } from "./downloadTicket.vue?vue&type=template&id=64925b22"
import script from "./downloadTicket.vue?vue&type=script&lang=ts"
export * from "./downloadTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports